module.exports = __webpack_public_path__ + "img/backpeople.a43d2519.webp";